<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "询盘单号",
                "code": "no",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "label": "询盘名称",
                "code": "title",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Select",
                "label": "询盘类型",
                "code": "tradeType",
                "basic": true,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "Goods",
                        "label": "商品"
                    },
                    {
                        "value": "Servc",
                        "label": "服务"
                    }
                ]
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "发布日期",
                "code": "publishTime",
                "basic": true
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "截至日期",
                "code": "expireDate",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "标签",
                "code": "tag",
                "basic": true
            },
            {
                "type": "Text",
                "label": "申请人",
                "valueType": "String",
                "code": "applicantName"
            },
            {
                "type": "Text",
                "label": "交付地址",
                "valueType": "String",
                "code": "deliverAddr"
            }
        ],
        "sortFields": [
            {
                "label": "申请时间",
                "code": "applyTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "发布日期",
                "code": "publishTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "截至日期",
                "code": "expireDate",
                "order": "desc",
                "enabled": true
            }
        ]
    };

    export default {
        name: 'swb-deal-inqry-voucher-search',
        desc: '询价单搜索',
        props: ['no'],
        data: function () {
            return {
                queryConfig: null,
                queryKey: null,
                queryConfigMap: {}
            }
        },
        created: function () {
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //查询回调函数调用上下文对象
            //queryConfig.queryContext = this;
            //...
            this.queryConfig = queryConfig;

            this.queryConfigMap = queryConfig.queryFields.toMap("code");

            if(!Utils.isNoB(this.no)) {
                let queryConfigOb = this.queryConfigMap["no"];
                queryConfigOb.value = this.no;
            }
        },
        methods: {
            queryHandler(queryModel) {
                console.log('----------  查询、排序参数 ---------');

                console.log(queryModel);

                this.$emit("showDealInqryVoucherSearch", queryModel)
                //调用查询...
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealInqyVoucherSearch.vue